// Invatare Digitala - Main JS
$(document).ready(function () {
    console.log('Invatare Digitala loaded');
});
